import request from '../../axios';

const getStoreSupplierProfile = async () => {
  const {data}: {data: IStoreSupplierProfile} = await request.get(
    'api/v2/store/store-supplier-profile',
  );
  return data;
};

export default getStoreSupplierProfile;
